import { Observable } from 'rxjs';
import { LoadIdentifier } from '../../../shipment-load/models';
import { ShipmentLoadTrackingMapStateModel } from './shipment-load-tracking-map.state';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { ShipmentLoadTrackingMapLoad, ShipmentLoadTrackingMapInitialState } from './shipment-load-tracking-map.actions';
import { ShipmentLoadTrackingMapState } from './shipment-load-tracking-map.state';
import { ShipmentLoadMapData } from '../../models/shipment-load-tracking-map.model';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadTrackingMapFacade implements LoadDataFacade, SetInitialStateFacade {
  state$: Observable<ShipmentLoadTrackingMapStateModel> = this.store.select(ShipmentLoadTrackingMapState.getState);
  loaded$: Observable<boolean> = this.store.select(ShipmentLoadTrackingMapState.getLoaded);
  mapData$: Observable<ShipmentLoadMapData> = this.store.select(ShipmentLoadTrackingMapState.getMapData);

  constructor(private store: Store) {}

  loadAll(identifier: LoadIdentifier): void {
    this.store.dispatch(new ShipmentLoadTrackingMapLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentLoadTrackingMapInitialState());
  }
}
